/**
 * The platforms' marks, small and in one colour, for the Composer's Remix tools (Dax, 2026-10-04). Simple
 * drawings in a 16 by 16 box, filled in the current colour like the toolbar's other glyphs; no artwork is
 * loaded from anywhere.
 */
import type { ComposeRemixTarget } from '@studio/contracts';

const MARKS: Record<ComposeRemixTarget, string> = {
  // A note with a curled flag.
  tiktok: 'M9 1.8h2.3c.2 1.5 1.2 2.6 2.9 2.8v2.3c-1.1 0-2.1-.3-2.9-.9v4.6A3.7 3.7 0 1 1 7.6 7v2.4a1.4 1.4 0 1 0 1.4 1.4z',
  // A rounded camera: the body as a ring, the lens as a ring, the flash a dot.
  instagram: 'M5 1.8h6A3.2 3.2 0 0 1 14.2 5v6a3.2 3.2 0 0 1-3.2 3.2H5A3.2 3.2 0 0 1 1.8 11V5A3.2 3.2 0 0 1 5 1.8z M5 3.2A1.8 1.8 0 0 0 3.2 5v6A1.8 1.8 0 0 0 5 12.8h6a1.8 1.8 0 0 0 1.8-1.8V5A1.8 1.8 0 0 0 11 3.2z M8 4.8a3.2 3.2 0 1 1 0 6.4a3.2 3.2 0 0 1 0-6.4z M8 6.2a1.8 1.8 0 1 0 0 3.6a1.8 1.8 0 0 0 0-3.6z M11.6 3.6a.8.8 0 1 1 0 1.6a.8.8 0 0 1 0-1.6z',
  // A rounded screen with a play triangle cut out of it.
  youtube: 'M4 3h8a2.6 2.6 0 0 1 2.6 2.6v4.8A2.6 2.6 0 0 1 12 13H4a2.6 2.6 0 0 1-2.6-2.6V5.6A2.6 2.6 0 0 1 4 3z M6.6 5.6v4.8L10.6 8z',
};

export function PlatformMark({ target }: { target: ComposeRemixTarget }) {
  return (
    <svg className="platform-mark" viewBox="0 0 16 16" aria-hidden="true">
      <path d={MARKS[target]} fillRule="evenodd" />
    </svg>
  );
}
